module.exports = __webpack_public_path__ + "img/back_normal.1eee31c8.png";